import { Falcon } from '@pocketlaw/tetris/macro';
import { ListButton } from '../ListButton';
export function MetadataButton() {
    return <ListButton settingsKey="metadata" icon={<Falcon icon="tag"/>}/>;
}
